import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/departments',
    name: 'department_list',
    component: () => import('@/views/pages/departments/DepartmentList.vue'),
    meta: {
      pageTitle: 'Department List',
      breadcrumb: {
        label: 'Department List'
      },
      roles: [ROLES.ADMIN]
      // verticalMenu: {
      //   title: 'Department List',
      //   icon: 'BriefcaseIcon',
      //   parent: 'settingsGroup'
      // }
    }
  },
  {
    path: '/departments/create',
    name: 'create_department',
    component: () => import('@/views/pages/departments/CreateDepartment.vue'),
    meta: {
      pageTitle: 'Create Department',
      breadcrumb: {
        label: 'Create Department',
        parent: 'department_list'
      },
      roles: [ROLES.ADMIN]
    }
  },
  {
    path: '/departments/:id',
    name: 'edit_department',
    component: () => import('@/views/pages/departments/EditDepartment.vue'),
    meta: {
      pageTitle: 'Edit Department',
      breadcrumb: {
        label: 'Edit Department',
        parent: 'department_list'
      },
      roles: [ROLES.ADMIN]
    }
  },
  {
    path: '/departments/:id/rules',
    name: 'departments_rules',
    component: () => import('@/views/pages/departments/rule/DepartmentRuleList.vue'),
    meta: {
      pageTitle: 'Department Rule Sets',
      breadcrumb: {
        label: 'Department Rule Sets',
        parent: 'department_list'
      },
      roles: [ROLES.ADMIN]
    }
  },
  {
    path: '/departments/:id/rules/create',
    name: 'departments_rule_create',
    component: () => import('@/views/pages/departments/rule/CreateDepartmentRule.vue'),
    meta: {
      pageTitle: 'Create Department Rule Set',
      breadcrumb: {
        label: 'Create Department Rule Set',
        parent: 'departments_rules'
      },
      roles: [ROLES.ADMIN]
    }
  },
  {
    path: '/departments/:id/rules/:ruleId',
    name: 'edit_department_rule',
    component: () => import('@/views/pages/departments/rule/EditDepartmentRule.vue'),
    meta: {
      pageTitle: 'Edit Department Rule',
      breadcrumb: {
        label: 'Edit Department Rule',
        parent: 'departments_rules'
      },
      roles: [ROLES.ADMIN]
    }
  }
];
